<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" template="<i class='fa-solid fa-circle-notch fa-spin fa-3x primary-clr'></i>"></ngx-spinner>
  <div class="page">
    <router-outlet></router-outlet>
  </div>
